(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3073],{

/***/ 6010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clsx */
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["Z"] = (clsx);

/***/ }),

/***/ 5420:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/build-your-own/[url]",
      function () {
        return __webpack_require__(854);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _url_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/styles/pages/build-your-own/custom-box.module.scss
var custom_box_module = __webpack_require__(1200);
var custom_box_module_default = /*#__PURE__*/__webpack_require__.n(custom_box_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs + 3 modules
var use_in_view = __webpack_require__(7037);
// EXTERNAL MODULE: ./src/components/button/Button.tsx
var Button = __webpack_require__(6151);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(5678);
// EXTERNAL MODULE: ./src/styles/components/button/index.module.scss
var index_module = __webpack_require__(3086);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/redux/with-redux-store.tsx + 1 modules
var with_redux_store = __webpack_require__(2705);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/redux/action/cartActions.tsx
var cartActions = __webpack_require__(6184);
;// CONCATENATED MODULE: ./src/components/add-to-cart-button/AddToCartButton.tsx







const AddToCartButton = (param)=>{
    let { children , selectedHoneyList =[] , productLimit , clearSelection , ...props } = param;
    /**
     * To manage cart data globally
     */ const dispatch = (0,es/* useDispatch */.I0)();
    // @ts-ignore
    const sidrCart = (0,es/* useSelector */.v9)((state)=>state.sidrCart);
    const handleOnClick = (e)=>{
        let isBoxExist = false;
        for (const product of sidrCart.entities){
            if (product.lineItem.customAttributes.length > 0) {
                isBoxExist = true;
            }
        }
        if (!isBoxExist) {
            const uniqueId = "".concat(productLimit, "-box-").concat(new Date().getTime());
            // @ts-ignore
            if (selectedHoneyList.length == productLimit) {
                let productList = [];
                for (const product1 of selectedHoneyList){
                    // @ts-ignore
                    productList.push({
                        ...product1.shopifyProduct,
                        quantity: 5
                    });
                }
                const payload = {
                    id: uniqueId,
                    type: "".concat(productLimit, "-box"),
                    products: productList,
                    isCustomBox: true
                };
                (0,cartActions/* addCustomBoxToCart */.YY)(payload, sidrCart, dispatch, ()=>{
                    if (clearSelection) {
                        clearSelection();
                    }
                });
            }
        } else {
            react_toastify_esm/* toast.info */.Am.info("Maximum 1 gift box allowed.", {
                toastId: "1",
                icon: (param)=>/*#__PURE__*/ {
                    let { theme , type  } = param;
                    return (0,jsx_runtime.jsx)("img", {
                        src: "/assets/images/decorations/extra/ic_toast_message.svg",
                        alt: "close"
                    });
                }
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "".concat((index_module_default()).button, " ").concat(props.classes ? props.classes : ""),
        disabled: props.disabled,
        onClick: handleOnClick,
        ...props,
        children: children
    });
};
/* harmony default export */ var add_to_cart_button_AddToCartButton = ((0,with_redux_store/* withRedux */.X)(AddToCartButton));

// EXTERNAL MODULE: ./src/redux/store.tsx + 9 modules
var store = __webpack_require__(4627);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(8116);
// EXTERNAL MODULE: ./src/styles/components/build-your-own/product-detail/index.module.scss
var product_detail_index_module = __webpack_require__(31);
var product_detail_index_module_default = /*#__PURE__*/__webpack_require__.n(product_detail_index_module);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(719);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.scss
var swiper = __webpack_require__(2618);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.scss
var pagination = __webpack_require__(2099);
// EXTERNAL MODULE: ./node_modules/swiper/modules/effect-fade/effect-fade.scss
var effect_fade = __webpack_require__(2013);
;// CONCATENATED MODULE: ./src/components/build-your-own/product-detail/build-your-own-product-detail.tsx






// Import Swiper styles






react.useLayoutEffect = react.useEffect;
// @ts-ignore
const BuildYourOwnProductDetail = (param)=>{
    let { index , id , closeView , addToBox , product , nuritionalInformation  } = param;
    var _product_metafields, _product_metafields1, _product_metafields2, _product_metafields3;
    // Setting up current image in main view
    const [currentImage, setCurrentImage] = (0,react.useState)(product.images[0]);
    // Promo code input value
    const [promoCode, setPromoCode] = (0,react.useState)("");
    // Configuration for swiper for image slider
    const swiperConfig = {
        modules: [
            swiper_esm/* Navigation */.W_,
            swiper_esm/* Pagination */.tl,
            swiper_esm/* Scrollbar */.LW,
            swiper_esm/* A11y */.s5,
            swiper_esm/* EffectFade */.xW
        ],
        spaceBetween: 36.6,
        fade: "true",
        mousewheel: true,
        loop: true,
        initialSlide: 0,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        }
    };
    /**
     * To manage cart data globally
     */ const dispatch = (0,es/* useDispatch */.I0)();
    // @ts-ignore
    const sidrCart = (0,es/* useSelector */.v9)((state)=>state.sidrCart);
    (0,react.useEffect)(()=>{
        if (sidrCart.checkout) {
            const checkOutCart = JSON.parse(sidrCart.checkout);
            if (checkOutCart.discountApplications && checkOutCart.discountApplications.length > 0) {
                setPromoCode(checkOutCart.discountApplications[0].code);
                setIsPromoCodeApply(1);
            } else {
                setIsPromoCodeApply(0);
                setPromoCode("");
            }
        }
    }, [
        sidrCart
    ]);
    const [isPromoCodeApply, setIsPromoCodeApply] = (0,react.useState)(0);
    const applyDiscount = ()=>{
        if (promoCode != "") {
            (0,cartActions/* addDiscount */.R0)(promoCode, sidrCart, dispatch, (success, errorMessage)=>{
                if (success) setIsPromoCodeApply(1);
                else setIsPromoCodeApply(2);
            });
        }
    };
    /**
     * This section contain images of product and main image view, description, price, in stock, promo code and add to cart
     */ // @ts-ignore
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (product_detail_index_module_default()).product_list,
        id: id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "vertical_slider",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                            ...swiperConfig,
                            slidesPerView: "auto",
                            breakpoints: {
                                320: {
                                    slidesPerView: 1,
                                    spaceBetween: 0,
                                    direction: "horizontal"
                                },
                                481: {
                                    direction: "vertical"
                                }
                            },
                            children: [
                                product.images.map((image, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: image.originalSrc,
                                            alt: image.altText,
                                            loading: "lazy",
                                            fill: true,
                                            onClick: ()=>{
                                                setCurrentImage(product.images[index]);
                                            }
                                        })
                                    }, "honey-" + index);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "swiper-button-prev previous_button",
                                    tabIndex: 0,
                                    role: "button",
                                    "aria-label": "Previous slide",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/assets/images/decorations/extra/ic_up_arrow.svg",
                                        alt: "previous"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "swiper-button-next next_button",
                                    tabIndex: 0,
                                    role: "button",
                                    "aria-label": "Next slide",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/assets/images/decorations/extra/ic_down_arrow.svg",
                                        alt: "next"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "img_container_add_cart",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "img_container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: currentImage.originalSrc,
                                alt: currentImage.altText
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "divider",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product_detail_container_small_device",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "product_title",
                                children: product.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "short_description",
                                children: [
                                    product.metafields.sub_title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "small_title",
                                                children: product.metafields.sub_title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "seperator"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "product_sku",
                                        children: [
                                            "sku: ",
                                            product.variants[0].sku
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product_description",
                                dangerouslySetInnerHTML: {
                                    __html: product.descriptionHtml
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "list_information",
                                children: [
                                    ((_product_metafields = product.metafields) === null || _product_metafields === void 0 ? void 0 : _product_metafields.falvor) && product.metafields.falvor != "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "single_line",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Flavor:\xa0"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "item_value",
                                                    children: product.metafields.falvor
                                                })
                                            ]
                                        })
                                    }),
                                    ((_product_metafields1 = product.metafields) === null || _product_metafields1 === void 0 ? void 0 : _product_metafields1.grade) && product.metafields.grade != "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "single_line",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Grade:\xa0"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "item_value",
                                                    children: product.metafields.grade
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product_detail_container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "product_title",
                                children: product.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "short_description",
                                children: [
                                    product.metafields.sub_title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "small_title",
                                                children: product.metafields.sub_title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "seperator"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "product_sku",
                                        children: [
                                            "sku: ",
                                            product.variants[0].sku
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product_description",
                                dangerouslySetInnerHTML: {
                                    __html: product.descriptionHtml
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "list_information",
                                children: [
                                    ((_product_metafields2 = product.metafields) === null || _product_metafields2 === void 0 ? void 0 : _product_metafields2.falvor) && product.metafields.falvor != "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "single_line",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Flavor:\xa0"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "item_value",
                                                    children: product.metafields.falvor
                                                })
                                            ]
                                        })
                                    }),
                                    ((_product_metafields3 = product.metafields) === null || _product_metafields3 === void 0 ? void 0 : _product_metafields3.grade) && product.metafields.grade != "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "single_line",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Grade:\xa0"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "item_value",
                                                    children: product.metafields.grade
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "information",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "Name"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "%DV"
                                                        })
                                                    ]
                                                }),
                                                nuritionalInformation.map((item, index)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                        className: item.isTopBorderHighLighted ? "highlighted_border" : "",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                children: [
                                                                    item.isNormal ? item.title : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: item.title
                                                                    }),
                                                                    " ",
                                                                    item.weight
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: item.value
                                                                }
                                                            })
                                                        ]
                                                    }, "nuritional-information-" + index);
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pricing_add_to_cart",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container_price",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "price_in_stock",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                "$",
                                                Number(product.variants[0].price.amount).toFixed(2)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: product.totalInventory > 0 ? "in stock" : "out of stock"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "promo_code_add_to_box",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "content",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "promo_code_box ".concat(isPromoCodeApply == 1 ? "correct" : isPromoCodeApply == 2 ? "incorrect" : ""),
                                                    children: isPromoCodeApply == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/images/decorations/extra/ic_check_mark.svg",
                                                        alt: "checkmark"
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        placeholder: "promo code",
                                                        onKeyPress: (event)=>{
                                                            if (event.key === "Enter") {
                                                                applyDiscount();
                                                            }
                                                        },
                                                        onChange: (e)=>setPromoCode(e.target.value)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    onClick: addToBox,
                                                    disabled: product.totalInventory == 0,
                                                    classes: product.totalInventory == 0 ? "add_box_disabled" : "",
                                                    children: "add to box"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Items in the cart cannot be reserved until the purchase is complete."
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: "close_view",
                onClick: ()=>{
                    if (closeView) closeView();
                },
                src: "/assets/images/decorations/extra/ic_close.svg",
                alt: "close"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/config/HoneyDataList.tsx
const NuritionalInformationHoney = [
    {
        title: "Calories",
        weight: "60",
        value: ""
    },
    {
        title: "Total Fat",
        weight: "0g",
        value: "0%"
    },
    {
        title: "Saturated Fat",
        weight: "0g",
        value: "0%"
    },
    {
        title: "Trans Fat",
        weight: "0g",
        value: "-"
    },
    {
        title: "Sodium",
        weight: "0mg",
        value: "0%",
        isTopBorderHighLighted: true
    },
    {
        title: "Total Carbs",
        weight: "17g",
        value: "6%"
    },
    {
        title: "Total Sugars",
        weight: "17g",
        value: "",
        isNormal: true
    },
    {
        title: "",
        weight: "",
        value: "34%<sup>&#8593;</sup>"
    },
    {
        title: "Protein",
        weight: "0g",
        value: "0%"
    }
];
const ProductDataList = {
    "honey": {
        description: {
            h3: "eco-friendly",
            h4: "pure honey harvest",
            description: "Immerse yourself in the purest essence of nature with our unfiltered ingredients: honey. We skip the ordinary, capturing raw, unadulterated honey that embodies the very soul of a bountiful honey harvest. It's nature's gift, untouched and eco-conscious. Taste the extraordinary in every jar and join us in preserving the essence of our planet."
        },
        bottom_section: {
            image: "/assets/images/decorations/product_list/honey_jar_bulk_section.webp",
            title: "bulk honey",
            secondary_title: "wholesale",
            description: "Discover the magic of unfiltered and raw honey with our wholesale gourmet market offerings. Elevate your culinary creations with the purest honey in bulk. Taste the excellence in every drop.",
            link: "/buy-in-bulk",
            link_title: "buy now"
        }
    },
    "honey-packet": {
        description: {
            h3: "single serve pack",
            h4: "multi benefits honey",
            description: "Elevate your day with our single-serve packs of honey, packed with the pure, unfiltered essence of raw honey. Discover the multi benefits of this golden elixir, conveniently portioned for on-the-go sweetness. From a natural energy boost to a sweet tea companion, our honey packets redefine the way you enjoy with one ingredient: honey."
        },
        bottom_section: {
            image: "/assets/images/decorations/product_list/honey_packet_bulk_section.webp",
            title: "bulk honey packets",
            secondary_title: "wholesale",
            description: "Uncover the enchantment of unfiltered, raw honey with our gourmet market's bulk honey packs. Elevate your creations with pure excellence in single-serve premium honey packets.",
            link: "/buy-in-bulk",
            link_title: "buy now"
        }
    }
};

;// CONCATENATED MODULE: ./src/pages/build-your-own/[url].tsx












// @ts-ignore
function CustomGiftBox(param) {
    let { giftBoxDetail , allProductsDetail , strapiProducts  } = param;
    /**
     * To rearrange the detail view this action will tell us that the pages is rendered
     * so once rendered we can update the div list.
     */ const firstRender = (0,react.useRef)(true);
    (0,react.useEffect)(()=>{
        if (firstRender.current) {
            firstRender.current = false;
            reArrangeDetailViews();
            return;
        }
    });
    // Animation of image when scrolling and in view for honey
    const elementsRefHoney = (0,react.useRef)(strapiProducts.map(()=>/*#__PURE__*/ (0,react.createRef)()));
    // @ts-ignore
    const isInViewHoney = elementsRefHoney.current.map((ref, _)=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return (0,use_in_view/* useInView */.Y)(ref, {
            once: false
        });
    });
    /**
     * Selected honey list
     */ const [selectedHoneyList, setSelectedHoneyList] = (0,react.useState)([]);
    /**
     * Slide up and down animation for toast
     */ const slideInOutTransition = (0,react_toastify_esm/* cssTransition */.vU)({
        collapse: false,
        enter: "slide-in-toast",
        exit: "slide-out-toast"
    });
    /***
     * Add to box action for honey
     * @param e
     * @param honey
     * @param isAdd
     * @param index
     */ const actionHoneyInList = function(e, honey) {
        let isAdd = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, index = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : -1;
        if (e) {
            e.stopPropagation();
        }
        if (isAdd) {
            if (selectedHoneyList.length < giftBoxDetail.productLimit) {
                honey.selected = true;
                setSelectedHoneyList([
                    ...selectedHoneyList,
                    honey
                ]);
            } else {
                react_toastify_esm/* toast.info */.Am.info("You can select maximum ".concat(giftBoxDetail.productLimit, " items."), {
                    toastId: "1",
                    icon: (param)=>/*#__PURE__*/ {
                        let { theme , type  } = param;
                        return (0,jsx_runtime.jsx)("img", {
                            src: "/assets/images/decorations/extra/ic_toast_message.svg",
                            alt: "close"
                        });
                    }
                });
            }
        } else {
            if (index > -1) {
                honey.selected = false;
                let productList = [
                    ...selectedHoneyList
                ];
                productList.splice(index, 1);
                setSelectedHoneyList(productList);
            }
        }
    };
    /***
     * used to store selected product detail view.
     */ // @ts-ignore
    const [activeDetailElement, setActiveDetailElement] = (0,react.useState)(null);
    /***
     * opening detail view for honey product
     * @param e
     * @param index
     */ const actionClickHoney = (e, index)=>{
        if (e) {
            e.stopPropagation();
        }
        if (activeDetailElement) {
            activeDetailElement.classList.remove("active_detail");
        }
        const htmlElement = document.getElementById("honey-detail-" + index);
        // @ts-ignore
        htmlElement.classList.add("active_detail");
        // @ts-ignore
        setActiveDetailElement(htmlElement);
    };
    const getProductDetail = (productHandle)=>{
        return allProductsDetail.find((product)=>product.handle == productHandle);
    };
    /***
     * Arranging details view based on view.
     */ const reArrangeDetailViews = ()=>{
        for(let index = 0; index < strapiProducts.length; index++){
            const itemRef = elementsRefHoney.current[index];
            // @ts-ignore
            const parentWidth = itemRef.current.parentElement.getBoundingClientRect().width;
            // @ts-ignore
            const itemWidth = itemRef.current.getBoundingClientRect().width;
            const perRowColumn = Math.round(parentWidth / itemWidth);
            const row = Math.ceil((index + 1) / perRowColumn);
            const htmlElement = document.getElementById("honey-detail-" + index);
            let insertIndex = perRowColumn * row;
            if (insertIndex >= elementsRefHoney.current.length) {
                // @ts-ignore
                itemRef.current.parentElement.append(htmlElement);
            } else {
                // @ts-ignore
                itemRef.current.parentElement.insertBefore(htmlElement, elementsRefHoney.current[insertIndex].current);
            }
        }
    };
    const closeDetailView = ()=>{
        if (activeDetailElement) {
            activeDetailElement.classList.remove("active_detail");
        }
        // @ts-ignore
        setActiveDetailElement(null);
    };
    /**
     * The page contain header and footer component
     * This is custom gift box so based on box type user can select 2 or 3 jars/boxes.
     * also on product click user can see the detail of the product and create a gift-box based on their preference
     */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (custom_box_module_default()).banner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: giftBoxDetail.bannerImage,
                        alt: giftBoxDetail.bannerImageAlt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "small-text",
                        children: "build your own"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: giftBoxDetail.title
                    }),
                    selectedHoneyList.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "do a ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " great start with ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "selecting"
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "selected products"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product_count",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "honey packet"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: selectedHoneyList.length
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "products",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: selectedHoneyList.map((item, index)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: item.attributes.Image.data.attributes.url,
                                                    alt: item.attributes.Image.data.attributes.alternativeText
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "line"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: item.attributes.Title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "remove_img",
                                                    onClick: (event)=>{
                                                        actionHoneyInList(event, item, false, index);
                                                    },
                                                    src: "/assets/images/decorations/extra/ic_close.svg",
                                                    alt: "remove"
                                                })
                                            ]
                                        }, "honey-" + index);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "clear_add_to_cart",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        classes: "clear_btn",
                                        onClick: ()=>{
                                            strapiProducts.map((honey)=>{
                                                honey.selected = false;
                                                return honey;
                                            });
                                            setSelectedHoneyList([]);
                                        },
                                        children: "clear all"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(add_to_cart_button_AddToCartButton, {
                                        classes: "",
                                        selectedHoneyList: selectedHoneyList,
                                        productLimit: giftBoxDetail.productLimit,
                                        clearSelection: ()=>{
                                            strapiProducts.map((honey)=>{
                                                honey.selected = false;
                                                return honey;
                                            });
                                            setSelectedHoneyList([]);
                                        },
                                        children: "add to cart"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (custom_box_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "the_finest_text",
                        dangerouslySetInnerHTML: {
                            __html: giftBoxDetail.main_title
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "description",
                        dangerouslySetInnerHTML: {
                            __html: giftBoxDetail.description
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product_title",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: giftBoxDetail.secondary_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: giftBoxDetail.secondary_description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "product_list_honey",
                        className: "product_list honey",
                        onClick: (e)=>{
                            // @ts-ignore
                            if (e.target && e.target.id == "product_list_honey") {
                                closeDetailView();
                            }
                        },
                        children: [
                            strapiProducts.map((item, index)=>{
                                // @ts-ignore
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    ref: elementsRefHoney.current[index],
                                    className: "item item_honey",
                                    onClick: (e)=>{
                                        closeDetailView();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            loading: "lazy",
                                            className: "img_honey ".concat(isInViewHoney[index] ? "slide-up-animation-active" : "slide-up-animation"),
                                            src: item.attributes.Image.data.attributes.url,
                                            alt: item.attributes.Image.data.attributes.alternativeText,
                                            onClick: (e)=>{
                                                actionClickHoney(e, index);
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "bar_line bar_line_honey",
                                            onClick: (e)=>{
                                                actionClickHoney(e, index);
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            onClick: (e)=>{
                                                actionClickHoney(e, index);
                                            },
                                            children: item.attributes.Title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "add_to_cart ".concat(item.selected ? "item_selected" : ""),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                        })
                                    ]
                                }, "product-" + index);
                            }),
                            strapiProducts.map((item, index)=>{
                                const boxType = giftBoxDetail.type == "two-jars" ? "" : "-".concat(giftBoxDetail.type);
                                const product = getProductDetail(item.attributes.Shopify_Link + "-honey-packet-gift-box");
                                item.shopifyProduct = product;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Provider */.zt, {
                                    store: store/* sidrStore */.F,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildYourOwnProductDetail, {
                                            index: index,
                                            id: "honey-detail-" + index,
                                            closeView: closeDetailView,
                                            product: product,
                                            nuritionalInformation: NuritionalInformationHoney,
                                            addToBox: ()=>{
                                                actionHoneyInList(null, item);
                                                closeDetailView();
                                            }
                                        }, "honey-detail-" + index),
                                        " "
                                    ]
                                }, "honey-detail-" + index);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {
                position: "bottom-left",
                autoClose: 5000,
                limit: 1,
                hideProgressBar: true,
                newestOnTop: false,
                closeOnClick: true,
                rtl: false,
                pauseOnFocusLoss: true,
                draggable: true,
                pauseOnHover: true,
                theme: "dark",
                transition: slideInOutTransition,
                className: (custom_box_module_default()).toast
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var _url_ = (CustomGiftBox);


/***/ }),

/***/ 31:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","product_list":"product-detail_product_list__vpgFL","about-image-in":"product-detail_about-image-in__S6xPt","fade-in-honeycomb":"product-detail_fade-in-honeycomb__JlIfR","dot-falling":"product-detail_dot-falling__WEuma","dot-falling-before":"product-detail_dot-falling-before__Y_skX","dot-falling-after":"product-detail_dot-falling-after__uUrJL"};

/***/ }),

/***/ 1200:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","banner":"custom-box_banner__wZ1bp","container":"custom-box_container__462TE","toast":"custom-box_toast__U38KO","about-image-in":"custom-box_about-image-in__Yd_CL","fade-in-honeycomb":"custom-box_fade-in-honeycomb__iJjOy","dot-falling":"custom-box_dot-falling__6hW_7","dot-falling-before":"custom-box_dot-falling-before__s51s_","dot-falling-after":"custom-box_dot-falling-after__AI8nM"};

/***/ }),

/***/ 2013:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2099:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2618:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7037:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ useInView; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/utils/resolve-elements.es.js
function resolveElements(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : (selectorCache[elements] = document.querySelectorAll(elements));
            elements = selectorCache[elements];
        }
        else {
            elements = document.querySelectorAll(elements);
        }
    }
    else if (elements instanceof Element) {
        elements = [elements];
    }
    /**
     * Return an empty array
     */
    return Array.from(elements || []);
}



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/is-function.es.js
const isFunction = (value) => typeof value === "function";



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/gestures/in-view.es.js



const thresholds = {
    any: 0,
    all: 1,
};
function inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = "any" } = {}) {
    /**
     * If this browser doesn't support IntersectionObserver, return a dummy stop function.
     * Default triggering of onStart is tricky - it could be used for starting/stopping
     * videos, lazy loading content etc. We could provide an option to enable a fallback, or
     * provide a fallback callback option.
     */
    if (typeof IntersectionObserver === "undefined") {
        return () => { };
    }
    const elements = resolveElements(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */
            if (entry.isIntersecting === Boolean(onEnd))
                return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if (isFunction(newOnEnd)) {
                    activeIntersections.set(entry.target, newOnEnd);
                }
                else {
                    observer.unobserve(entry.target);
                }
            }
            else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === "number" ? amount : thresholds[amount],
    });
    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs



function useInView(ref, { root, margin, amount, once = false } = {}) {
    const [isInView, setInView] = (0,react.useState)(false);
    (0,react.useEffect)(() => {
        if (!ref.current || (once && isInView))
            return;
        const onEnter = () => {
            setInView(true);
            return once ? undefined : () => setInView(false);
        };
        const options = {
            root: (root && root.current) || undefined,
            margin,
            amount: amount === "some" ? "any" : amount,
        };
        return inView(ref.current, onEnter, options);
    }, [root, ref, margin, once]);
    return isInView;
}




/***/ }),

/***/ 5678:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Am": function() { return /* binding */ Q; },
/* harmony export */   "Ix": function() { return /* binding */ k; },
/* harmony export */   "vU": function() { return /* binding */ h; }
/* harmony export */ });
/* unused harmony exports Bounce, Flip, Icons, Slide, Zoom, collapseToast, useToast, useToastContainer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6010);
'use client';
const u=t=>"number"==typeof t&&!isNaN(t),d=t=>"string"==typeof t,p=t=>"function"==typeof t,m=t=>d(t)||p(t)?t:null,f=t=>(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(t)||d(t)||p(t)||u(t);function g(t,e,n){void 0===n&&(n=300);const{scrollHeight:o,style:s}=t;requestAnimationFrame(()=>{s.minHeight="initial",s.height=o+"px",s.transition=`all ${n}ms`,requestAnimationFrame(()=>{s.height="0",s.padding="0",s.margin="0",setTimeout(e,n)})})}function h(e){let{enter:a,exit:r,appendPosition:i=!1,collapse:l=!0,collapseDuration:c=300}=e;return function(e){let{children:u,position:d,preventExitTransition:p,done:m,nodeRef:f,isIn:h}=e;const y=i?`${a}--${d}`:a,v=i?`${r}--${d}`:r,T=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);return (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(()=>{const t=f.current,e=y.split(" "),n=o=>{o.target===f.current&&(t.dispatchEvent(new Event("d")),t.removeEventListener("animationend",n),t.removeEventListener("animationcancel",n),0===T.current&&"animationcancel"!==o.type&&t.classList.remove(...e))};t.classList.add(...e),t.addEventListener("animationend",n),t.addEventListener("animationcancel",n)},[]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{const t=f.current,e=()=>{t.removeEventListener("animationend",e),l?g(t,m,c):m()};h||(p?e():(T.current=1,t.className+=` ${v}`,t.addEventListener("animationend",e)))},[h]),react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,u)}}function y(t,e){return null!=t?{content:t.content,containerId:t.props.containerId,id:t.props.toastId,theme:t.props.theme,type:t.props.type,data:t.props.data||{},isLoading:t.props.isLoading,icon:t.props.icon,status:e}:{}}const v={list:new Map,emitQueue:new Map,on(t,e){return this.list.has(t)||this.list.set(t,[]),this.list.get(t).push(e),this},off(t,e){if(e){const n=this.list.get(t).filter(t=>t!==e);return this.list.set(t,n),this}return this.list.delete(t),this},cancelEmit(t){const e=this.emitQueue.get(t);return e&&(e.forEach(clearTimeout),this.emitQueue.delete(t)),this},emit(t){this.list.has(t)&&this.list.get(t).forEach(e=>{const n=setTimeout(()=>{e(...[].slice.call(arguments,1))},0);this.emitQueue.has(t)||this.emitQueue.set(t,[]),this.emitQueue.get(t).push(n)})}},T=e=>{let{theme:n,type:o,...s}=e;return react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",{viewBox:"0 0 24 24",width:"100%",height:"100%",fill:"colored"===n?"currentColor":`var(--toastify-icon-color-${o})`,...s})},E={info:function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(T,{...e},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{d:"M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"}))},warning:function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(T,{...e},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{d:"M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"}))},success:function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(T,{...e},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{d:"M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"}))},error:function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(T,{...e},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{d:"M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"}))},spinner:function(){return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"Toastify__spinner"})}};function C(t){const[,o]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(t=>t+1,0),[l,c]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),g=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),h=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new Map).current,T=t=>-1!==l.indexOf(t),C=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({toastKey:1,displayedToast:0,count:0,queue:[],props:t,containerId:null,isToastActive:T,getToast:t=>h.get(t)}).current;function b(t){let{containerId:e}=t;const{limit:n}=C.props;!n||e&&C.containerId!==e||(C.count-=C.queue.length,C.queue=[])}function I(t){c(e=>null==t?[]:e.filter(e=>e!==t))}function _(){const{toastContent:t,toastProps:e,staleId:n}=C.queue.shift();O(t,e,n)}function L(t,n){let{delay:s,staleId:r,...i}=n;if(!f(t)||function(t){return!g.current||C.props.enableMultiContainer&&t.containerId!==C.props.containerId||h.has(t.toastId)&&null==t.updateId}(i))return;const{toastId:l,updateId:c,data:T}=i,{props:b}=C,L=()=>I(l),N=null==c;N&&C.count++;const M={...b,style:b.toastStyle,key:C.toastKey++,...Object.fromEntries(Object.entries(i).filter(t=>{let[e,n]=t;return null!=n})),toastId:l,updateId:c,data:T,closeToast:L,isIn:!1,className:m(i.className||b.toastClassName),bodyClassName:m(i.bodyClassName||b.bodyClassName),progressClassName:m(i.progressClassName||b.progressClassName),autoClose:!i.isLoading&&(R=i.autoClose,w=b.autoClose,!1===R||u(R)&&R>0?R:w),deleteToast(){const t=y(h.get(l),"removed");h.delete(l),v.emit(4,t);const e=C.queue.length;if(C.count=null==l?C.count-C.displayedToast:C.count-1,C.count<0&&(C.count=0),e>0){const t=null==l?C.props.limit:1;if(1===e||1===t)C.displayedToast++,_();else{const n=t>e?e:t;C.displayedToast=n;for(let t=0;t<n;t++)_()}}else o()}};var R,w;M.iconOut=function(t){let{theme:n,type:o,isLoading:s,icon:r}=t,i=null;const l={theme:n,type:o};return!1===r||(p(r)?i=r(l):(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(r)?i=(0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(r,l):d(r)||u(r)?i=r:s?i=E.spinner():(t=>t in E)(o)&&(i=E[o](l))),i}(M),p(i.onOpen)&&(M.onOpen=i.onOpen),p(i.onClose)&&(M.onClose=i.onClose),M.closeButton=b.closeButton,!1===i.closeButton||f(i.closeButton)?M.closeButton=i.closeButton:!0===i.closeButton&&(M.closeButton=!f(b.closeButton)||b.closeButton);let x=t;(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(t)&&!d(t.type)?x=(0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(t,{closeToast:L,toastProps:M,data:T}):p(t)&&(x=t({closeToast:L,toastProps:M,data:T})),b.limit&&b.limit>0&&C.count>b.limit&&N?C.queue.push({toastContent:x,toastProps:M,staleId:r}):u(s)?setTimeout(()=>{O(x,M,r)},s):O(x,M,r)}function O(t,e,n){const{toastId:o}=e;n&&h.delete(n);const s={content:t,props:e};h.set(o,s),c(t=>[...t,o].filter(t=>t!==n)),v.emit(4,y(s,null==s.props.updateId?"added":"updated"))}return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>(C.containerId=t.containerId,v.cancelEmit(3).on(0,L).on(1,t=>g.current&&I(t)).on(5,b).emit(2,C),()=>{h.clear(),v.emit(3,C)}),[]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{C.props=t,C.isToastActive=T,C.displayedToast=l.length}),{getToastToRender:function(e){const n=new Map,o=Array.from(h.values());return t.newestOnTop&&o.reverse(),o.forEach(t=>{const{position:e}=t.props;n.has(e)||n.set(e,[]),n.get(e).push(t)}),Array.from(n,t=>e(t[0],t[1]))},containerRef:g,isToastActive:T}}function b(t){return t.targetTouches&&t.targetTouches.length>=1?t.targetTouches[0].clientX:t.clientX}function I(t){return t.targetTouches&&t.targetTouches.length>=1?t.targetTouches[0].clientY:t.clientY}function _(t){const[o,a]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1),[r,l]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1),c=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),u=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({start:0,x:0,y:0,delta:0,removalDistance:0,canCloseOnClick:!0,canDrag:!1,boundingRect:null,didMove:!1}).current,d=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t),{autoClose:m,pauseOnHover:f,closeToast:g,onClick:h,closeOnClick:y}=t;function v(e){if(t.draggable){"touchstart"===e.nativeEvent.type&&e.nativeEvent.preventDefault(),u.didMove=!1,document.addEventListener("mousemove",_),document.addEventListener("mouseup",L),document.addEventListener("touchmove",_),document.addEventListener("touchend",L);const n=c.current;u.canCloseOnClick=!0,u.canDrag=!0,u.boundingRect=n.getBoundingClientRect(),n.style.transition="",u.x=b(e.nativeEvent),u.y=I(e.nativeEvent),"x"===t.draggableDirection?(u.start=u.x,u.removalDistance=n.offsetWidth*(t.draggablePercent/100)):(u.start=u.y,u.removalDistance=n.offsetHeight*(80===t.draggablePercent?1.5*t.draggablePercent:t.draggablePercent/100))}}function T(e){if(u.boundingRect){const{top:n,bottom:o,left:s,right:a}=u.boundingRect;"touchend"!==e.nativeEvent.type&&t.pauseOnHover&&u.x>=s&&u.x<=a&&u.y>=n&&u.y<=o?C():E()}}function E(){a(!0)}function C(){a(!1)}function _(e){const n=c.current;u.canDrag&&n&&(u.didMove=!0,o&&C(),u.x=b(e),u.y=I(e),u.delta="x"===t.draggableDirection?u.x-u.start:u.y-u.start,u.start!==u.x&&(u.canCloseOnClick=!1),n.style.transform=`translate${t.draggableDirection}(${u.delta}px)`,n.style.opacity=""+(1-Math.abs(u.delta/u.removalDistance)))}function L(){document.removeEventListener("mousemove",_),document.removeEventListener("mouseup",L),document.removeEventListener("touchmove",_),document.removeEventListener("touchend",L);const e=c.current;if(u.canDrag&&u.didMove&&e){if(u.canDrag=!1,Math.abs(u.delta)>u.removalDistance)return l(!0),void t.closeToast();e.style.transition="transform 0.2s, opacity 0.2s",e.style.transform=`translate${t.draggableDirection}(0)`,e.style.opacity="1"}}(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{d.current=t}),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>(c.current&&c.current.addEventListener("d",E,{once:!0}),p(t.onOpen)&&t.onOpen((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(t.children)&&t.children.props),()=>{const t=d.current;p(t.onClose)&&t.onClose((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(t.children)&&t.children.props)}),[]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>(t.pauseOnFocusLoss&&(document.hasFocus()||C(),window.addEventListener("focus",E),window.addEventListener("blur",C)),()=>{t.pauseOnFocusLoss&&(window.removeEventListener("focus",E),window.removeEventListener("blur",C))}),[t.pauseOnFocusLoss]);const O={onMouseDown:v,onTouchStart:v,onMouseUp:T,onTouchEnd:T};return m&&f&&(O.onMouseEnter=C,O.onMouseLeave=E),y&&(O.onClick=t=>{h&&h(t),u.canCloseOnClick&&g()}),{playToast:E,pauseToast:C,isRunning:o,preventExitTransition:r,toastRef:c,eventHandlers:O}}function L(e){let{closeToast:n,theme:o,ariaLabel:s="close"}=e;return react__WEBPACK_IMPORTED_MODULE_0__.createElement("button",{className:`Toastify__close-button Toastify__close-button--${o}`,type:"button",onClick:t=>{t.stopPropagation(),n(t)},"aria-label":s},react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",{"aria-hidden":"true",viewBox:"0 0 14 16"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{fillRule:"evenodd",d:"M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"})))}function O(e){let{delay:n,isRunning:o,closeToast:s,type:a="default",hide:r,className:i,style:l,controlledProgress:u,progress:d,rtl:m,isIn:f,theme:g}=e;const h=r||u&&0===d,y={...l,animationDuration:`${n}ms`,animationPlayState:o?"running":"paused",opacity:h?0:1};u&&(y.transform=`scaleX(${d})`);const v=(0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("Toastify__progress-bar",u?"Toastify__progress-bar--controlled":"Toastify__progress-bar--animated",`Toastify__progress-bar-theme--${g}`,`Toastify__progress-bar--${a}`,{"Toastify__progress-bar--rtl":m}),T=p(i)?i({rtl:m,type:a,defaultClassName:v}):(0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(v,i);return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{role:"progressbar","aria-hidden":h?"true":"false","aria-label":"notification timer",className:T,style:y,[u&&d>=1?"onTransitionEnd":"onAnimationEnd"]:u&&d<1?null:()=>{f&&s()}})}const N=n=>{const{isRunning:o,preventExitTransition:s,toastRef:r,eventHandlers:i}=_(n),{closeButton:l,children:u,autoClose:d,onClick:m,type:f,hideProgressBar:g,closeToast:h,transition:y,position:v,className:T,style:E,bodyClassName:C,bodyStyle:b,progressClassName:I,progressStyle:N,updateId:M,role:R,progress:w,rtl:x,toastId:$,deleteToast:k,isIn:P,isLoading:B,iconOut:D,closeOnClick:A,theme:z}=n,F=(0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("Toastify__toast",`Toastify__toast-theme--${z}`,`Toastify__toast--${f}`,{"Toastify__toast--rtl":x},{"Toastify__toast--close-on-click":A}),H=p(T)?T({rtl:x,position:v,type:f,defaultClassName:F}):(0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(F,T),S=!!w||!d,q={closeToast:h,type:f,theme:z};let Q=null;return!1===l||(Q=p(l)?l(q):(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(l)?(0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(l,q):L(q)),react__WEBPACK_IMPORTED_MODULE_0__.createElement(y,{isIn:P,done:k,position:v,preventExitTransition:s,nodeRef:r},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{id:$,onClick:m,className:H,...i,style:E,ref:r},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{...P&&{role:R},className:p(C)?C({type:f}):(0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("Toastify__toast-body",C),style:b},null!=D&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:(0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("Toastify__toast-icon",{"Toastify--animate-icon Toastify__zoom-enter":!B})},D),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",null,u)),Q,react__WEBPACK_IMPORTED_MODULE_0__.createElement(O,{...M&&!S?{key:`pb-${M}`}:{},rtl:x,theme:z,delay:d,isRunning:o,isIn:P,closeToast:h,hide:g,type:f,style:N,className:I,controlledProgress:S,progress:w||0})))},M=function(t,e){return void 0===e&&(e=!1),{enter:`Toastify--animate Toastify__${t}-enter`,exit:`Toastify--animate Toastify__${t}-exit`,appendPosition:e}},R=h(M("bounce",!0)),w=h(M("slide",!0)),x=h(M("zoom")),$=h(M("flip")),k=(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((e,n)=>{const{getToastToRender:o,containerRef:a,isToastActive:r}=C(e),{className:i,style:l,rtl:u,containerId:d}=e;function f(t){const e=(0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("Toastify__toast-container",`Toastify__toast-container--${t}`,{"Toastify__toast-container--rtl":u});return p(i)?i({position:t,rtl:u,defaultClassName:e}):(0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(e,m(i))}return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{n&&(n.current=a.current)},[]),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{ref:a,className:"Toastify",id:d},o((e,n)=>{const o=n.length?{...l}:{...l,pointerEvents:"none"};return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:f(e),style:o,key:`container-${e}`},n.map((e,o)=>{let{content:s,props:a}=e;return react__WEBPACK_IMPORTED_MODULE_0__.createElement(N,{...a,isIn:r(a.toastId),style:{...a.style,"--nth":o+1,"--len":n.length},key:`toast-${a.key}`},s)}))}))});k.displayName="ToastContainer",k.defaultProps={position:"top-right",transition:R,autoClose:5e3,closeButton:L,pauseOnHover:!0,pauseOnFocusLoss:!0,closeOnClick:!0,draggable:!0,draggablePercent:80,draggableDirection:"x",role:"alert",theme:"light"};let P,B=new Map,D=[],A=1;function z(){return""+A++}function F(t){return t&&(d(t.toastId)||u(t.toastId))?t.toastId:z()}function H(t,e){return B.size>0?v.emit(0,t,e):D.push({content:t,options:e}),e.toastId}function S(t,e){return{...e,type:e&&e.type||t,toastId:F(e)}}function q(t){return(e,n)=>H(e,S(t,n))}function Q(t,e){return H(t,S("default",e))}Q.loading=(t,e)=>H(t,S("default",{isLoading:!0,autoClose:!1,closeOnClick:!1,closeButton:!1,draggable:!1,...e})),Q.promise=function(t,e,n){let o,{pending:s,error:a,success:r}=e;s&&(o=d(s)?Q.loading(s,n):Q.loading(s.render,{...n,...s}));const i={isLoading:null,autoClose:null,closeOnClick:null,closeButton:null,draggable:null},l=(t,e,s)=>{if(null==e)return void Q.dismiss(o);const a={type:t,...i,...n,data:s},r=d(e)?{render:e}:e;return o?Q.update(o,{...a,...r}):Q(r.render,{...a,...r}),s},c=p(t)?t():t;return c.then(t=>l("success",r,t)).catch(t=>l("error",a,t)),c},Q.success=q("success"),Q.info=q("info"),Q.error=q("error"),Q.warning=q("warning"),Q.warn=Q.warning,Q.dark=(t,e)=>H(t,S("default",{theme:"dark",...e})),Q.dismiss=t=>{B.size>0?v.emit(1,t):D=D.filter(e=>null!=t&&e.options.toastId!==t)},Q.clearWaitingQueue=function(t){return void 0===t&&(t={}),v.emit(5,t)},Q.isActive=t=>{let e=!1;return B.forEach(n=>{n.isToastActive&&n.isToastActive(t)&&(e=!0)}),e},Q.update=function(t,e){void 0===e&&(e={}),setTimeout(()=>{const n=function(t,e){let{containerId:n}=e;const o=B.get(n||P);return o&&o.getToast(t)}(t,e);if(n){const{props:o,content:s}=n,a={delay:100,...o,...e,toastId:e.toastId||t,updateId:z()};a.toastId!==t&&(a.staleId=t);const r=a.render||s;delete a.render,H(r,a)}},0)},Q.done=t=>{Q.update(t,{progress:1})},Q.onChange=t=>(v.on(4,t),()=>{v.off(4,t)}),Q.POSITION={TOP_LEFT:"top-left",TOP_RIGHT:"top-right",TOP_CENTER:"top-center",BOTTOM_LEFT:"bottom-left",BOTTOM_RIGHT:"bottom-right",BOTTOM_CENTER:"bottom-center"},Q.TYPE={INFO:"info",SUCCESS:"success",WARNING:"warning",ERROR:"error",DEFAULT:"default"},v.on(2,t=>{P=t.containerId||t,B.set(P,t),D.forEach(t=>{v.emit(0,t.content,t.options)}),D=[]}).on(3,t=>{B.delete(t.containerId||t),0===B.size&&v.off(0).off(1).off(5)});
//# sourceMappingURL=react-toastify.esm.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,9774,2888,179], function() { return __webpack_exec__(5420); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);